import FxxlError from '@fxxl/error';

export default class FxxlEffects {

    /**
     * showAndHideContainer
     *
     * @param {HTMLElement} showElement
     * @param {HTMLElement} hideElement
     * @param {object} options
     */
    static showAndHideContainer(showElement, hideElement, options = {}) {
        const animationTime = 250;
        const defaultOptions = {
            effectDirection: 'right_to_left'
        };
        options = Object.assign(defaultOptions, options);
        const valid = FxxlEffects.validateShowAndHideContainerOptions(options);

        if (valid === true) {
            const hiddenClass = 'fxxl-hidden';

            let effectDirection = 1;
            if (options.effectDirection === 'left_to_right') {
                effectDirection = -1;
            }

            showElement.style.transform = `translate3d(${effectDirection * (window.innerWidth + 100)}px, 0, 0)`;
            showElement.style.transition = `transform ${animationTime}ms`;
            showElement.classList.remove(hiddenClass);
            hideElement.classList.add(hiddenClass);
            showElement.fxxlShowAndHideContainerActive = true;
            hideElement.fxxlShowAndHideContainerActive = false;
            requestAnimationFrame(() => {
                showElement.style.transform = 'translate3d(0, 0, 0)';
                setTimeout(() => showElement.style.removeProperty('transform'), animationTime);
            });
        }
    }

    /**
     * Hier wird überprüft, ob die optionalen Parameter gültig sind.
     *
     * @param {object} options
     * @returns {boolean}
     */
    static validateShowAndHideContainerOptions(options) {
        let result = true;
        const validEffectDirections = new Set(['right_to_left', 'left_to_right']);

        // Überprüfen, ob effectDirection einen gültigen Wert hat
        if (validEffectDirections.has(options.effectDirection) === false) {
            new FxxlError(`Ungültiger Wert für effectDirection. Verwende ${Array.from(validEffectDirections).map(val => `"${val}"`).join(' oder ')}.`);
            result = false;
        }

        // Ausgabe
        return result;
    }


    /**
     * Fxxl FadeOut Effekt
     *
     * @param {Object} element
     * @param {function} callback
     */
    static fadeOutElement(element, callback = null) {
        element.style.opacity = 1;

        (function fade() {
            if ((element.style.opacity -= .1) <= 0) {
                element.style.display = 'none';
                typeof callback == 'function' && callback();
            } else {
                requestAnimationFrame(fade);
            }
        })();
    }

    /**
     * Fxxl FadeIn Effekt
     *
     * @param {Object} element
     * @param {string} display
     * @param {function} callback
     */
    static fadeInElement (element, display = 'block', callback = null) {
        element.style.opacity = 0;
        element.style.display = display;

        (function fade() {
            let opacity = parseFloat(element.style.opacity);

            if ( !((opacity += .1) >= 1) ) {
                element.style.opacity = opacity;
                requestAnimationFrame(fade);
            } else {
                typeof callback == 'function' && callback();
            }
        })();
    }
}
